import { createFileRoute } from "@tanstack/react-router";
import { NewsletterPage } from "@/components/newsletter/NewsletterPage";
import { newsletterSeo } from "@/lib/page-seo";

export const Route = createFileRoute("/newsletter")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) => newsletterSeo(loaderData?.href ?? "/newsletter"),
  component: NewsletterPage,
});
